import { render, staticRenderFns } from "./ArticlesPagination.vue?vue&type=template&id=37e0d862&scoped=true"
import script from "./ArticlesPagination.vue?vue&type=script&lang=js"
export * from "./ArticlesPagination.vue?vue&type=script&lang=js"
import style0 from "./ArticlesPagination.vue?vue&type=style&index=0&id=37e0d862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0d862",
  null
  
)

export default component.exports